(function () {
  window.addEventListener("pageshow", () => {
    const checkboxes = document.querySelectorAll('input.js-cart__terms-checkbox');
    checkboxes.forEach(function(curr, index) {
      const sibling = curr.nextElementSibling;
      sibling.classList.add('unchecked');
    });
  });

  window.addEventListener('DOMContentLoaded', () => {
    // Terms and sales
    const checkboxes = document.querySelectorAll('input.js-cart__terms-checkbox');
    const checkout = document.querySelectorAll('button.js-cart__checkout');

    checkboxes.forEach(function(curr, index) {
      curr.addEventListener('change', function(event) {
        const label = curr.nextElementSibling;
        if (event.currentTarget.checked) {
          curr.value = true;
          // checkout.disabled = false;
          label.classList.remove('unchecked');
          checkout.forEach(function(item, index) {
            item.disabled = false;
          })
        } else {
          curr.value = false;
          // checkout.disabled = true;
          label.classList.add('unchecked');
          checkout.forEach(function(item, index) {
            item.disabled = true;
          })
        }
      })
    });

    // Remove item in mini cart
    document.addEventListener('click', function(e) {
      let removeItem = e.target.classList.contains('js-cart-remove-item') ? e.target : e.target.closest('.js-cart-remove-item');

      if (removeItem) {
        e.preventDefault();
        let parent = e.target.closest('.cart__item');
        let cartWrapper = parent.querySelector('.js-qty__wrapper');
        let cartItemId = cartWrapper.dataset.id;
        let productPdp = document.querySelector('.js-product-details .js-product-details__info');

        if (productPdp !== null) {
          let activeVariant = productPdp.querySelector('div.product-details__volume-item--active');
          let variant = productPdp.querySelectorAll('div.js-product-details__volume-item');

          if (activeVariant.dataset.id === cartItemId) {
            productPdp.dataset.cartQuantity = '';
            activeVariant.dataset.cartQuantity = '';
          }

          variant.forEach(function(v) {
            if (v.dataset.id === cartItemId) {
              v.dataset.cartQuantity = '';
            }
          })
        }

        let key = removeItem.closest('.cart__item').dataset.key;
        window.theme.cart.changeItem(key, 0)
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        }.bind(this))
        .catch(function(XMLHttpRequest){});
      }
    });

    window.theme.CartForm.CartForm;
  })
})();